import React from "react";

import dynamic from "next/dynamic";
import Container from "ui/Container/Container";
import Grid from "ui/Grid/Grid";
import footerStyles from "common/Footer/Footer.module.scss";
import YandexWidgetReviews from "common/YandexWidgetReviews/YandexWidgetReviews";
import Logo from "assets/icons/logo_new.svg";
import Contacts from "./components/Contacts/Contacts";
import Apps from "./components/Apps/Apps";
import Bottom from "./components/Bottom/Bottom";
import Copyright from "./components/Copyright/Copyright";
import Payments from "./components/Payments/Payments";
import styles from "./Footer.module.scss";

const Socials = dynamic(() => import("./components/Socials/Socials"));

type Props = {
  homeUrl: string;
};

const Footer: React.FC<Props> = ({ homeUrl }) => {
  return (
    <footer className={styles.footer500}>
      <div className={footerStyles.footerSection}>
        <Container>
          <Grid container flat spacing={20}>
            <Grid item sm={12} lg={3}>
              <div className={footerStyles.footerLogoContainer}>
                <Logo />
              </div>
              <Contacts homeUrl={homeUrl} />
              <Copyright showOnDesktop />
            </Grid>

            <Grid item sm={12} lg={5}>
              <div className={footerStyles.footerLinksContainer}>
                <div>
                  <Socials />
                  <Payments showOnDesktop />
                  <div className={styles.footer500OnlyLaptop}>
                    <YandexWidgetReviews />
                  </div>
                </div>
              </div>
            </Grid>

            <Grid item sm={12} lg={4}>
              <Apps />
            </Grid>
          </Grid>
        </Container>

        <Bottom />
      </div>
    </footer>
  );
};

export default Footer;
